import styled from "styled-components";
import LoadingBar from "./LoadingBar";
import { User } from "../types";
import { Goals } from "../quiz/goals";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageContainer } from "../common-ui/PageContainer";
import { CDN_ROOT } from "./images";
import { Caption } from "./QuestionFooter";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  .sd-title {
    color: #1e1e1e;
    flex-direction: row;
    white-space: normal;
    word-break: break-word;
  }

  * {
    scrollbar-color: #d6d6d6 transparent;
    scrollbar-width: thin;
  }
`;

const StyledPageContainer = styled(PageContainer)`
  display: flex;
  justify-content: center;
  padding-top: 0px;
  background-color: transparent;
  max-width: 500px;
  margin-top: 50px;
`;

const LoaderContainer = styled.div`
    width: 100%;
    max-width: 640px;
    padding: 16px 50px 32px 60px;
    box-sizing: border-box;
    margin: 0 auto;
    text-align: center;
`;

const loadingMessageKeys = [
  "splash.loading.messages.analyzing",
  "splash.loading.messages.calculating",
  "splash.loading.messages.preparing",
];

type LoadingPageProps = {
  user: User,
  onComplete: () => void;
}
const LoadingPage = ({ user, onComplete }: LoadingPageProps) => {
  const [visibleIndex, setVisibleIndex] = useState<number>(0);
  const { t } = useTranslation();
  const loadingMessages = useMemo(() => loadingMessageKeys.map((key) => t(key)), [t]);

  return (
    <>
      <div style={{
        padding: "8px 0 5px 0",
        background: "white",
        textAlign: "center",
        color: "#7A7A7A",
        fontSize: "12px",
      }}>
        {t("splash.headers.loading")}
      </div>
      <div className="sd-root-modern">
        <BodyWrapper>
          <StyledPageContainer>
            <div className="new-quote-container"> 
              <div className="splash-icon">✅</div>
              <h1>{t("splash.loading.titleBeforeName")}<div className="highlight"><span>{user.name}</span>{t("splash.loading.titleAfterName")}</div></h1>
              <div className="quote" style={{ textAlign: "center" }}>
                {t("splash.loading.text")}
              </div>
            </div>
          </StyledPageContainer>
        </BodyWrapper>
      </div>
      <LoaderContainer>
        <Caption>{loadingMessages[visibleIndex] ?? t("splash.loading.complete")}</Caption>
        <LoadingBar strings={loadingMessages} onComplete={onComplete} visibleIndex={visibleIndex} setVisibleIndex={setVisibleIndex} />
      </LoaderContainer>
    </>
  )
};

export {
  LoadingPage,
}
